export default {"src":"/_next/static/media/computer.05d6890f.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};